const styles = {
  logo: {
    color: 'white',
    fontSize: '1.125rem',
    fontWeight: 'bold',
    textDecoration: `none`,
  },
  top: {
    padding: '0 16px',
    boxSizing: 'border-box',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  list: {
    width: 250,
  },
  linkText: {
    textDecoration: `none`,
    textTransform: `uppercase`,
    color: `white`,
    fontSize: '1.125rem',
  },
};

export default styles;
